export const getBitcoinPrice = async (): Promise<number> => {
  const deribitUrl =
    "https://www.deribit.com/api/v2/public/get_index_price?index_name=btc_usd";

  const response = await fetch(deribitUrl);
  const data = await response.json();

  return data.result.index_price;
};
